<template>
    <div>
        <TopBackground :titles="'更改密码'" :smalls="smalls"/>
        <div class="user_container">
          <el-form  ref="form" :rules="rules"  :model="pwdForm" >
            <el-form-item prop="oldPassword">
              <el-input
                  v-model="pwdForm.oldPassword"
                  type="password"
                  auto-complete="off"
                  placeholder="原密码"
                  >
              </el-input>
            </el-form-item>
            <el-form-item prop="newPassword">
              <el-input
                  v-model="pwdForm.newPassword"
                  type="password"
                  auto-complete="off"
                  placeholder="新密码"
              >

              </el-input>
            </el-form-item>
            <el-form-item prop="newPassword2">
              <el-input
                  v-model="pwdForm.newPassword2"
                  type="password"
                  auto-complete="off"
                  placeholder="确认新密码"
              >
              </el-input>
            </el-form-item>

            <el-form-item style="width:100%;">
              <el-button
                  @click="submit"
                  size="medium"
                  type="primary"
                  style="width:100%;"
              >
                <span>确认更改</span>
              </el-button>

            </el-form-item>
          </el-form>
        </div>

    </div>
</template>
<script>
  import request from "@/util/request";
  export  default {
    data(){
      return {
        rules:{
          oldPassword:[{required:true,message:'请输入',trigger: 'change'}],
          newPassword:[{required:true,message:'请输入',trigger: 'change'}],
          newPassword2:[{required:true,message:'请输入',trigger: 'change'}]

        },
        pwdForm:{password:null,oldPassword:null,newPassword:null}
      }
    },
    methods:{
      submit(){
        this.$refs['form'].validate(v=>{
          if(v){
            if(this.newPassword!=this.newPassword2){
              this.$message.error("两次密码不一致")
              return;
            }
            request.post('/system/doctor/update/pwd',this.pwdForm).then(res=>{
              if(res.status==200){
                this.$message.success("修改成功")
                localStorage.clear()
                this.$router.push({path:'/login'})
              }else{
                this.$message.error(res.msg)
              }
            })
          }else{
            return
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
    .user_container {
        width: 1200px;
        margin: 39px auto 0;
    }



</style>
